import { render, staticRenderFns } from "./itemActivityForm.vue?vue&type=template&id=03e37af9"
import script from "./itemActivityForm.vue?vue&type=script&lang=js"
export * from "./itemActivityForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03e37af9')) {
      api.createRecord('03e37af9', component.options)
    } else {
      api.reload('03e37af9', component.options)
    }
    module.hot.accept("./itemActivityForm.vue?vue&type=template&id=03e37af9", function () {
      api.rerender('03e37af9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/file/itemActivityForm.vue"
export default component.exports